import { getFromLocal } from "config/axiosInstance";
import useShimmer from "hooks/useShrimmer";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { paymentStatusApi } from "services/survey";
import MySurveyShrimmer from "shrimmer/Survey/MySurveyShrimmer";
import { toast } from "sonner";

const ReceiveSubscriptionResponse = () => {
  //********************************* Handle All State ********************************//

  const navigate = useNavigate();
  const location = useLocation();
  const [showShimmer, setShowShimmer] = useShimmer(MySurveyShrimmer);

  // const getNavigation = (status) => {
  //   if (status) {
  //     navigate("dashboard/pricing?tapStatus=currentPlan", { replace: true });
  //     return;
  //   }
  //   console.log("redirection to failed subscription");
  //   navigate("dashboard/pricing?tapStatus=Subscription", { replace: true });
  // };

  //********************************* Handle All Function ********************************//

  //   Function for check payment status
  const getPaymentStatusHandler = async (chargeId) => {
    try {
      const reqData = {
        tapId: chargeId,
        token: getFromLocal(),
      };

      const response = await paymentStatusApi(reqData);
      const { status, message } = response;
      if (status === 200) {
        toast.success(message);
        navigate("/dashboard/pricing?tapStatus=currentPlan", { replace: true });
        // getNavigation(true);
      } else {
        toast.error(message);
        // const url = ;
        navigate("/dashboard/pricing?tapStatus=Subscription", {
          replace: true,
        });
        // getNavigation(false);
      }
    } catch (err) {
      console.error("Error fetching survey categories:", err);
    } finally {
      setShowShimmer(false);
    }
  };

  const getQueryParams = () => {
    setShowShimmer(true);
    const queryParams = new URLSearchParams(location.search);
    const tap_Id = queryParams.get("tap_id");
    getPaymentStatusHandler(tap_Id);
  };

  // effect for get search params
  useEffect(() => {
    getQueryParams();
    // eslint-disable-next-line
  }, []);

  //********************************* Handle HTML CODE ********************************//
  return (
    <div className="participant_criteria structure_preview">
      <h3 className="dashboard_title">Please Wait... </h3>
      {showShimmer}
    </div>
  );
};

export default ReceiveSubscriptionResponse;
